import SecurePayments from './SecurePayments';

export default SecurePayments;
